import type { Component } from 'solid-js'

type Props = {
  title: string
  onResume: () => void
}

/**
 * 一時停止している間に番組が切り替わったときに出す（要件定義 3.5）。
 * 放送そのものは進んでいるので、戻る操作はユーザーに委ねる。
 */
export const NextProgramNotice: Component<Props> = (props) => (
  <div class="rounded-ch border border-ch-border bg-ch-surface px-4 py-3">
    <p class="text-[11px] font-semibold tracking-[0.18em] text-ch-muted">NEXT PROGRAM</p>
    <p class="mt-1 text-sm">新しい番組が始まっています。</p>
    <p class="mt-0.5 truncate text-xs text-ch-dim">{props.title}</p>
    <button
      type="button"
      onClick={props.onResume}
      class="mt-3 inline-flex items-center gap-1.5 rounded-full bg-ch-elevated px-3 py-1.5 text-xs font-semibold hover:bg-ch-border"
    >
      ▶ 放送に戻る
    </button>
  </div>
)
